<style lang="sass" scoped>
.dist-ctn
    ::v-deep .el-input
        width: 100%
        margin-bottom: 10px
        text-align: center
        border: 1px solid rgba(40,39,41,.2)
        input
            padding-left: 0

    .tree
        height: 360px
        overflow: auto
        overflow-x: hidden
        ::v-deep .el-checkbox
            position: relative
            top: -1px

.dist_input
    height: 28px
    overflow: hidden
    padding-left: 10px
    position: relative
    cursor: pointer

    .item-ctn
      width: 195px
      color: #666
      display: flex
      flex-wrap: wrap
      &.ellipsis
        position: relative
        &::after
          content: '...'
          position: absolute
          right: 0
          top: 4px
          font-weight: bold
          line-height: 1
        .choose-item:not(:last-of-type)
          margin-right: 12px
    > i
        position: absolute
        right: 10px
        top: 8px
        color: #c0c4cc
        line-height: 1
    .choose-item
        width: fit-content
        max-width: calc(100% - 12px)
        display: flex
        align-items: center
        justify-content: flex-start
        flex-wrap: nowrap
        border-radius: 4px
        padding: 0 4px
        height: 28px
        line-height: 28px
        background: #F5F5F5
        &:not(:last-of-type)
          margin-right: 5px
        span
            flex: 0 0 auto
            max-width: calc(100% - 15px)
            font-size: 12px
            overflow: hidden
            white-space: nowrap
        .icon-shibai
            flex-shrink: 0
            cursor: pointer
            margin-top: 1px
            margin-left: 1px
            color: #D4D4D4
            &:hover
                color: #999
</style>

<template lang="pug">
el-popover(placement="bottom" trigger="click" popper-class="gg-dist form_pop" @hide="popHide" @show="isHide = false")
  .dist_input(slot="reference")
    .item-ctn(ref="itemCtn" :class="{'ellipsis': isShowEllipsis}" :title="isShowEllipsis ? allNames : ''")
      span(v-if="chooseDist.length == 0" style="display: inline-block;color: #999;margin-top: 1px;") 请选择
      <template>
        .choose-item(v-for="(item, i) in chooseDist" :key="i")
          span {{item.name}}
          span(v-if="checkCodes.indexOf(item.guid + '') < 0 && item.children && item.children.length") ({{spread(item.children)}})
          i.iconfont.icon-shibai(@click="delChooseItem(item, i)")
      </template>
    i.el-icon-arrow-down(v-if="isHide")
    i.el-icon-arrow-up(v-else)

  .dist-ctn
    el-input(size="mini" placeholder="输入禁播标签名称" v-model="curValue" @focus="show=true;notSearch=false" @blur="show=false;notSearch=true")
    .tree
      el-tree(
        ref="tree"
        icon-class="iconfont icon-biaodan-xuanzezhankai"
        show-checkbox
        size="mini"
        node-key="code"
        :data="noPlayLabels"
        :props="{ children: 'children', label: 'value' }"
        :default-checked-keys="checkCodes"
        :filter-node-method="filterNode"
        @check="chooseChange"
        @node-click="clickExpand")
        span.custom-tree-node(slot-scope="{ node, data }" style="display:flex;justify-content:space-between;width:100%;line-height:28px;padding-right:10px;")
          span
            img(v-if="data.levelNum<7" src="../assets/tree_icon_1.png")
            img(v-else-if="data.levelNum>7" src="../assets/tree_icon_3.png")
            img(v-else-if="data.levelNum==7" src="../assets/tree_icon_2.png")
            span(style="margin-left:8px;") {{node.label}}
</template>

<script>
export default {
  name: 'NoPlayingLabelSelector',
  props: [ 'value','text', 'v', 'parentProp' ],
  data () {
    return {
      curValue: '',
      show: false,
      notSearch: true,
      filterNum: 1000,
      chooseDistArr: [],
      checkCodes: [],
      chooseDist: [],
      isShowEllipsis: false,
      isHide: true,
      searchTimer: null,
      oldStr: '',
    }
  },
  watch: {
    value(v){
      const dictItems = this.$store.state.common['NEW_NO_PLAY_LABLE']
      this.chooseDist = []
      this.$refs.tree.setCheckedNodes([])
      this.value.filter(el => {
        dictItems.map(item=>{
         if(item.dictItemName === el){
           this.$refs.tree.setChecked(item.dictItemName, true, true)
            this.chooseDist.push({ code: item.dictItemName, name: item.dictItemName, value: item.dictItemName, children:[]})
          }
        })
      })
    },
    curValue (v) {
      v = v ? v.trim() : ''
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        console.log("wyt debug filter :"+v)
        this.$refs.tree.filter(v)
      }, 200)
    }
  },
  computed: {
    noPlayLabels () {
      const dictItems = this.$store.state.common['NEW_NO_PLAY_LABLE']
      return dictItems.map(item=>{
        return {
          code: item.dictItemName,
          value: item.dictItemName,
          name: item.dictItemName,
          children:[]
        }
      })
    },
    spanClass () {
      if(this.show) return 'active'
      if(this.curValue.trim() != '') return 'active'
      else return ''
    },
    spread () {
      return data => {
        return data.length === 1 ? data[0].name : data.length + '个区'
      }
    },
    allNames () {
      return this.chooseDist.map(x => x.name).join('、')
    }
  },
  methods: {
    async clickExpand (data, node, vm) {
    },
    topCheck (res) {
      let d = []
      let final = res.map(e => e.ids).sort()
      final.forEach(item => {
        d.forEach(e => {
          if ((item + '').indexOf(e) > -1) item = null
        })
        if (item) d.push(item + '')
      })
      return d
    },
    chooseChange (data) {
      // getCheckedNodes(p1, p2) p1:是否只是叶子节点,默认false, p2:是否包含半选节点,默认false
      let allChoose = this.$refs.tree.getCheckedNodes(false, true)
      let chooses = allChoose.map(el => {
        // 不拷贝下会直接改变原数据
        let each = JSON.parse(JSON.stringify(el))
        // 半选状态的子集可能包括所有的未勾选的子集，这里清空下子集
        each.children = []
        return each
      })

      // 合并成一棵树，赋值给this.chooseDistArr
      // 排序，以防父级在子集的后面   排序后有毛病？？
      // let cps = JSON.parse(JSON.stringify(chooses))
      // levelNum 较小的等级高的放前面，方便重组，sort貌似存在异常，先分开再合并
      // let cps1 = cps.filter(el => el.levelNum == 3).concat(cps.filter(el => el.levelNum == 4))
      let tree = []
      let repeat = function(arr, el) {
        arr.forEach(each => {
          if(each.code == el.parentCode){
            if(!each.children) each.children = []
            each.children.push(el)
            el.isRepeat = true
          }else {
            each.children && repeat(each.children, el)
          }
        })
      }
      chooses.forEach(el => {
        if(el.isRepeat) return false
        if(tree.length == 0) {
          tree.push(el)
          el.isRepeat = true
        }else {
          repeat(tree, el)
          if(!el.isRepeat){
            tree.push(el)
            el.isRepeat = true
          }
        }
      })
      this.chooseDistArr = tree
      if(!this.chooseDistArr || this.chooseDistArr.length == 0) {
        this.chooseDist = []
      } else {
        this.chooseDist = this.chooseDistArr.map(el => {
          el.name = el.value
          el.children && el.children.length > 0 && el.children.forEach(cd => { cd.name = cd.value })
          return el
        })
      }

      this.emitResult()
    },
    delChooseItem (item, i) {
      this.$refs.tree.setChecked(item.code, false, true)
      this.chooseDist.splice(i, 1)
      this.emitResult()
    },
    emitResult(){
      const ckNodes = this.$refs.tree.getCheckedNodes()
      const values = ckNodes.map(item=>item.value)
      this.handleEllipsis()
      this.$emit('input', values)
    },
    handleEllipsis () {
      this.$nextTick(() => {
        if (this.$refs.itemCtn && this.$refs.itemCtn.clientHeight > 40) this.isShowEllipsis = true
        else this.isShowEllipsis = false
      })
    },
    filterNode (value, data) {
      if(!value) return true
      return data.name.indexOf(value) !== -1
    },
    popHide(){
      this.isHide = true
    }
  }
}
</script>

<style lang="scss">
.gg-dist.el-popover {
  margin-left: -85px;
  width: 320px;
  border: 1px solid #282729;
  z-index: 2000 !important;
  .el-input {
    input {
      text-align: center;
      border: none;
      padding-right: 0;
    }
  }
  .el-tree-node__expand-icon {
    position: absolute;
    right: 0;
  }
}
</style>
